var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 8.969h-3.719V6.125a5.031 5.031 0 1 0-10.062 0v2.844H5.25A1.53 1.53 0 0 0 3.719 10.5v12.25a1.53 1.53 0 0 0 1.531 1.531h17.5a1.53 1.53 0 0 0 1.531-1.531V10.5a1.53 1.53 0 0 0-1.531-1.531M10.281 6.125a3.719 3.719 0 0 1 7.438 0v2.844H10.28zM22.97 22.75a.22.22 0 0 1-.219.219H5.25a.22.22 0 0 1-.219-.219V10.5a.22.22 0 0 1 .219-.219h17.5a.22.22 0 0 1 .219.219z"
  })));
};
export default SvgLock;